import styled from "styled-components"

import Icon from "@irati/ui/src/Icon"

export const StyledIcon = styled(Icon)`
  path:last-child {
    fill: ${({theme}) => theme.colors.greys.white};
  }
`
